module.exports = __webpack_public_path__ + "media/flags/io-dd268477.svg";